import { Box, Text, ToggleSwitch } from '@bechtel/gds';
import { FC, memo, useEffect, useState } from 'react';
import { CheckboxView } from '../../checkbox-view';

export interface ToolRoomToggleViewProps {
  onToggle: (status: boolean) => void;
  active: boolean;
  onAdhocEnabled: (status: boolean) => void;
  onTransferEnabled: (status: boolean) => void;
  isAdhocEnabled: boolean;
  isTransferEnabled: boolean;
}
export const ToolRoomToggleView: FC<ToolRoomToggleViewProps> = memo(
  ({ onToggle, active, isAdhocEnabled, isTransferEnabled, onTransferEnabled, onAdhocEnabled }) => {
    const [isActive, setIsActive] = useState<boolean>(active);
    const [adhocEnabled, setAdhocEnabled] = useState<boolean>(isAdhocEnabled);
    const [transferEnabled, setTransferEnabled] = useState<boolean>(isTransferEnabled);

    useEffect(() => {
      setIsActive(active);
      setAdhocEnabled(isAdhocEnabled);
      setTransferEnabled(isTransferEnabled);
    }, [active, isAdhocEnabled, isTransferEnabled]);

    const handleToggle = () => {
      const newStatus = !isActive;
      setIsActive(newStatus);
      onToggle(newStatus);

      // When activating, also enable both options
      if (newStatus) {
        setAdhocEnabled(true);
        setTransferEnabled(true);
        onAdhocEnabled(true);
        onTransferEnabled(true);
      }
    };
    return (
      <Box flexDirection={{ sm: 'column' }}>
        <Box gap={{ sm: '500' }}>
          <ToggleSwitch isToggled={isActive} onToggle={handleToggle} />
          <Text size="300" family="openSansRegular" color="blue.800">
            {isActive ? 'Active' : 'Inactive'}
          </Text>
        </Box>
        <Box mt={{ sm: '300' }} gap={{ sm: '500' }} alignItems={{ sm: 'center' }}>
          <CheckboxView
            checked={transferEnabled}
            disabled={isActive}
            onChange={() => {
              setTransferEnabled(!transferEnabled);
              onTransferEnabled(!transferEnabled);
            }}
          />
          <Text size="300" family="openSansRegular" color="grey.400">
            Transfer Available
          </Text>
        </Box>
        <Box mt={{ sm: '300' }} gap={{ sm: '500' }} alignItems={{ sm: 'center' }}>
          <CheckboxView
            checked={adhocEnabled}
            disabled={isActive}
            onChange={() => {
              setAdhocEnabled(!adhocEnabled);
              onAdhocEnabled(!adhocEnabled);
            }}
          />
          <Text size="300" family="openSansRegular" color="grey.400">
            Adhoc Available
          </Text>
        </Box>
      </Box>
    );
  }
);
